export default "__VITE_ASSET__CfjJ3cth__"